import { createLogic } from 'redux-logic'
import { bindRequestLogic } from './utils'
import CompanyTypes from '../actionTypes/company'
import { companyAPI, mailTemplateAPI, companyMailTemplateAPI } from '../api'

const getCompanies = bindRequestLogic({
  clientFunc: companyAPI.getCompanies,
  type: CompanyTypes.GET_COMPANIES_REQUEST,
  successType: CompanyTypes.GET_COMPANIES_SUCCESS,
  failType: CompanyTypes.GET_COMPANIES_FAILED,
  isQueryParam: true
})

const addCompany = bindRequestLogic({
  clientFunc: companyAPI.addCompany,
  type: CompanyTypes.ADD_COMPANY_REQUEST,
  successType: CompanyTypes.ADD_COMPANY_SUCCESS,
  failType: CompanyTypes.ADD_COMPANY_FAILED
})

const updateCompany = bindRequestLogic({
  clientFunc: companyAPI.updateCompany,
  type: CompanyTypes.UPDATE_COMPANY_REQUEST,
  successType: CompanyTypes.UPDATE_COMPANY_SUCCESS,
  failType: CompanyTypes.UPDATE_COMPANY_FAILED
})

const getCompanyDetail = bindRequestLogic({
  clientFunc: companyAPI.getCompanyDetail,
  type: CompanyTypes.GET_COMPANY_DETAIL_REQUEST,
  successType: CompanyTypes.GET_COMPANY_DETAIL_SUCCESS,
  failType: CompanyTypes.GET_COMPANY_DETAIL_FAILED,
  modelName: 'company'
})

const deleteCompany = bindRequestLogic({
  clientFunc: companyAPI.deleteCompany,
  type: CompanyTypes.DELETE_COMPANY_REQUEST,
  successType: CompanyTypes.DELETE_COMPANY_SUCCESS,
  failType: CompanyTypes.DELETE_COMPANY_FAILED
})

const updateSheetAdditional = bindRequestLogic({
  clientFunc: companyAPI.updateSheetAdditional,
  type: CompanyTypes.UPDATE_SHEET_ADDITIONAL_REQUEST,
  successType: CompanyTypes.UPDATE_SHEET_ADDITIONAL_SUCCESS,
  failType: CompanyTypes.UPDATE_SHEET_ADDITIONAL_FAILED
})

const getSheetAdditional = bindRequestLogic({
  clientFunc: companyAPI.getSheetAdditional,
  type: CompanyTypes.GET_SHEET_ADDITIONAL_REQUEST,
  successType: CompanyTypes.GET_SHEET_ADDITIONAL_SUCCESS,
  failType: CompanyTypes.GET_SHEET_ADDITIONAL_FAILED
})

const convertToMotherCompany = bindRequestLogic({
  clientFunc: companyAPI.convertToMotherCompany,
  type: CompanyTypes.CONVERT_TO_MOTHER_COMPANY_REQUEST,
  successType: CompanyTypes.CONVERT_TO_MOTHER_COMPANY_SUCCESS,
  failType: CompanyTypes.CONVERT_TO_MOTHER_COMPANY_FAILED
})

const getCompanyMembers = bindRequestLogic({
  clientFunc: companyAPI.getCompanyMembers,
  type: CompanyTypes.GET_COMPANY_MEMBERS_REQUEST,
  successType: CompanyTypes.GET_COMPANY_MEMBERS_SUCCESS,
  failType: CompanyTypes.GET_COMPANY_MEMBERS_FAILED,
  isQueryParam: true
})

const getCompanyPilots = bindRequestLogic({
  clientFunc: companyAPI.getCompanyPilots,
  type: CompanyTypes.GET_COMPANY_PILOTS_REQUEST,
  successType: CompanyTypes.GET_COMPANY_PILOTS_SUCCESS,
  failType: CompanyTypes.GET_COMPANY_PILOTS_FAILED,
  isQueryParam: true
})

const getChildrenCompanies = bindRequestLogic({
  clientFunc: companyAPI.getChildrenCompanies,
  type: CompanyTypes.GET_CHILDREN_COMPANIES_REQUEST,
  successType: CompanyTypes.GET_CHILDREN_COMPANIES_SUCCESS,
  failType: CompanyTypes.GET_CHILDREN_COMPANIES_FAILED,
  isQueryParam: true
})

const addChildrenCompany = bindRequestLogic({
  clientFunc: companyAPI.addChildrenCompany,
  type: CompanyTypes.ADD_CHILDREN_COMPANY_REQUEST,
  successType: CompanyTypes.ADD_CHILDREN_COMPANY_SUCCESS,
  failType: CompanyTypes.ADD_CHILDREN_COMPANY_FAILED
})

const deleteChildrenCompany = bindRequestLogic({
  clientFunc: companyAPI.deleteChildrenCompany,
  type: CompanyTypes.DELETE_CHILDREN_COMPANY_REQUEST,
  successType: CompanyTypes.DELETE_CHILDREN_COMPANY_SUCCESS,
  failType: CompanyTypes.DELETE_CHILDREN_COMPANY_FAILED
})

const getCompanySheetVehicle = bindRequestLogic({
  clientFunc: companyAPI.getCompanyVehicles,
  type: CompanyTypes.GET_COMPANY_VEHICLES_REQUEST,
  successType: CompanyTypes.GET_COMPANY_VEHICLES_SUCCESS,
  failType: CompanyTypes.GET_COMPANY_VEHICLES_FAILED,
  isQueryParam: true
})

const getCompanySubscriptions = bindRequestLogic({
  clientFunc: companyAPI.getCompanySubscription,
  type: CompanyTypes.GET_COMPANY_SUBSCRIPTIONS_REQUEST,
  successType: CompanyTypes.GET_COMPANY_SUBSCRIPTIONS_SUCCESS,
  failType: CompanyTypes.GET_COMPANY_SUBSCRIPTIONS_FAILED,
  isQueryParam: true
})

const getSystemCompanies = bindRequestLogic({
  clientFunc: companyAPI.getSystemCompanies,
  type: CompanyTypes.GET_SYSTEM_COMPANIES_REQUEST,
  successType: CompanyTypes.GET_SYSTEM_COMPANIES_SUCCESS,
  failType: CompanyTypes.GET_SYSTEM_COMPANIES_FAILED,
  isQueryParam: true
})

const getCompanyMailTemplates = bindRequestLogic({
  clientApi: mailTemplateAPI,
  clientFunc: mailTemplateAPI.getMailTemplates,
  type: CompanyTypes.GET_COMPANY_MAIL_TEMPLATES_REQUEST,
  successType: CompanyTypes.GET_COMPANY_MAIL_TEMPLATES_SUCCESS,
  failType: CompanyTypes.GET_COMPANY_MAIL_TEMPLATES_FAILED,
  isQueryParam: true,
  modelName: 'mailTemplates'
})

const getCompanyMailTemplateDetail = createLogic({
  type: CompanyTypes.GET_COMPANY_MAIL_TEMPLATE_DETAIL_REQUEST,
  latest: true,

  async process({ action }, dispatch, done) {
    const { onSuccess, onError } = action.meta
    try {
      const res = await companyMailTemplateAPI.getCompanyMailTemplateDetail(
        action?.payload
      )
      dispatch({
        type: CompanyTypes.GET_COMPANY_MAIL_TEMPLATE_DETAIL_SUCCESS,
        payload: {},
        meta: {}
      })
      onSuccess(res?.data?.compMailTemplateTrans)
    } catch (error) {
      onError('')
      dispatch({
        type: CompanyTypes.GET_COMPANY_MAIL_TEMPLATE_DETAIL_FAILED,
        payload: error.response,
        meta: {}
      })
    }
    done()
  }
})

const upsertCompanyMailTemplate = createLogic({
  type: CompanyTypes.UPSERT_COMPANY_MAIL_TEMPLATE_REQUEST,
  latest: true,

  async process({ action }, dispatch, done) {
    const { onSuccess, onError } = action.meta
    try {
      const { companyId, mailTemplateId, data } = action.payload

      const res = await companyMailTemplateAPI.upsetCompanyMailTemplate(
        companyId,
        mailTemplateId,
        data
      )
      dispatch({
        type: CompanyTypes.UPSERT_COMPANY_MAIL_TEMPLATE_SUCCESS,
        payload: {},
        meta: {}
      })
      onSuccess(res?.data?.compMailTemplateTrans)
    } catch (error) {
      onError('')
      dispatch({
        type: CompanyTypes.UPSERT_COMPANY_MAIL_TEMPLATE_FAILED,
        payload: error.response,
        meta: {}
      })
    }
    done()
  }
})

const deleteCompanyMailTemplate = createLogic({
  type: CompanyTypes.DELETE_COMPANY_MAIL_TEMPLATE_REQUEST,
  latest: true,

  async process({ action }, dispatch, done) {
    const { onSuccess, onError } = action.meta
    try {
      const { companyId, mailTemplateId } = action.payload

      const res = await companyMailTemplateAPI.deleteCompanyMailTemplate(
        companyId,
        mailTemplateId
      )
      dispatch({
        type: CompanyTypes.DELETE_COMPANY_MAIL_TEMPLATE_SUCCESS,
        payload: {},
        meta: {}
      })
      onSuccess(res?.data?.compMailTemplateTrans)
    } catch (error) {
      onError('')
      dispatch({
        type: CompanyTypes.DELETE_COMPANY_MAIL_TEMPLATE_FAILED,
        payload: error.response,
        meta: {}
      })
    }
    done()
  }
})

export const getProducedVehicles = bindRequestLogic({
  clientFunc: companyAPI.getProducedVehicles,
  type: CompanyTypes.GET_PRODUCED_VEHICLES_REQUEST,
  successType: CompanyTypes.GET_PRODUCED_VEHICLES_SUCCESS,
  failType: CompanyTypes.GET_PRODUCED_VEHICLES_FAILED
})

export const addProducedVehicle = bindRequestLogic({
  clientFunc: companyAPI.addProducedVehicle,
  type: CompanyTypes.ADD_PRODUCED_VEHICLE_REQUEST,
  successType: CompanyTypes.ADD_PRODUCED_VEHICLE_SUCCESS,
  failType: CompanyTypes.ADD_PRODUCED_VEHICLE_FAILED
})

export const deleteProducedVehicle = bindRequestLogic({
  clientFunc: companyAPI.deleteProducedVehicle,
  type: CompanyTypes.DELETE_PRODUCED_VEHICLE_REQUEST,
  successType: CompanyTypes.DELETE_PRODUCED_VEHICLE_SUCCESS,
  failType: CompanyTypes.DELETE_PRODUCED_VEHICLE_FAILED
})

export const getListLinkableVehicleLinks = bindRequestLogic({
  clientFunc: companyAPI.getListLinkableVehicleLinks,
  type: CompanyTypes.GET_LIST_LINKABLE_VEHICLE_REQUEST,
  successType: CompanyTypes.GET_LIST_LINKABLE_VEHICLE_SUCCESS,
  failType: CompanyTypes.GET_LIST_LINKABLE_VEHICLE_FAILED
})

export default [
  getCompanies,
  addCompany,
  getCompanyDetail,
  deleteCompany,
  updateCompany,
  updateSheetAdditional,
  getSheetAdditional,
  getCompanyMembers,
  getCompanyPilots,
  convertToMotherCompany,
  getChildrenCompanies,
  addChildrenCompany,
  deleteChildrenCompany,
  getCompanySheetVehicle,
  getCompanySubscriptions,
  getSystemCompanies,
  getCompanyMailTemplates,
  getCompanyMailTemplateDetail,
  upsertCompanyMailTemplate,
  deleteCompanyMailTemplate,
  getProducedVehicles,
  addProducedVehicle,
  deleteProducedVehicle,
  getListLinkableVehicleLinks
]
